import $ from 'jquery';

/**
 * Defines the className of the dot button
 * @type {string}
 */
export const DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
export default function customPaging(slider, i) {
  // try to get the slide's id to use in the link's href
  const id = slider.$slides[i].id || '';
  // Amount of images showing based on slidesToShow property
  const slidesShowing = slider.originalSettings.slidesToShow;
  // Total amount of images
  const slideCount = slider.slideCount;
  // Total number of pages(slides) - AKA: pagination dots
  const totalPages = Math.ceil(slider.slideCount/slider.originalSettings.slidesToShow);

  const $a = $(`<a href="#${id}" class="${DOT_CLASS}" data-role="none" aria-live="assertive">
  <span class="u-screen-reader">
    Showing <span class="slide-image-count">${slidesShowing}</span> of ${slideCount} images, page ${i + 1} of ${totalPages}
  </span>
  </a>`);
  return $a.on('click', e => e.preventDefault());
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/custom-paging.js